import { Injectable } from '@angular/core';
import {HttpClient} from "@angular/common/http";

@Injectable({
    providedIn: 'root'
})
export class MediaOrdersService {

    constructor(
        private http: HttpClient,
    ) {}

    async createOrUpdateMediaOrder(db: string, cdbTable: string, cdbId: string | number) {
        const mediaOrderDataResponse: any = await this.getNewMediaOrderInfo(db, cdbTable, cdbId);

        if (!mediaOrderDataResponse.data.media_order) {
            const mediaTypeIds = mediaOrderDataResponse.data.media_category.media_category_types.map((v: { media_type_id: number; }) => v.media_type_id);
            return await this.createNewMediaOrder(db, cdbTable, cdbId, mediaTypeIds);
        } else {
            const mediaTypeIds = mediaOrderDataResponse.data.media_order.missing_media_types.map((v: { id: number; }) => v.id);
            return await this.addMediaTypesToMediaOrder(mediaOrderDataResponse.data.media_order.id, mediaTypeIds);
        }
    }

    async createNewMediaOrder(db: string, cdbTable: string, cdbId: string | number, mediaTypeIds: any = [], priority: string = 'normal', comment: string|null = null) {
        if (!mediaTypeIds.length) {
            const mediaOrderDataResponse: any = await this.getNewMediaOrderInfo(db, cdbTable, cdbId);
            mediaTypeIds = mediaOrderDataResponse.data.media_category.media_category_types.map((v: { media_type_id: number; }) => v.media_type_id);
        }

        const payload = {
            cdb_table: cdbTable,
            cdb_id: cdbId,
            media_types: mediaTypeIds,
            priority: priority,
            comment: comment
        }

        return new Promise((resolve, reject) => {
            this.http.post(`/api/media/media_orders?db=${db}`, payload)
                .subscribe({
                    next(response: any) {
                        resolve(response);
                    },
                    error(err: any) {
                        reject(err);
                    }
                });
        });
    }

    async addMediaTypesToMediaOrder(mediaOrderId: number, mediaTypeIds: any[]) {
        const payload = {
            media_types: mediaTypeIds
        }

        return new Promise((resolve, reject) => {
            this.http.post(`/api/media/media_orders/${mediaOrderId}/media_types`, payload)
                .subscribe({
                    next(response: any) {
                        resolve(response);
                    },
                    error(err: any) {
                        reject(err);
                    }
                });
        });
    }

    async getNewMediaOrderInfo(db: string, cdbTable: string, cdbId: string | number) {
        return new Promise((resolve, reject) => {
            this.http.get(`/api/media/item_media/${cdbTable}/${cdbId}?db=${db}`)
                .subscribe({
                    next(response: any) {
                        resolve(response);
                    },
                    error(err: any) {
                        reject(err);
                    }
                });
        });
    }

    async createOrdersForAllSizes(table: string, cdb_id: string | number) {
        let mediaOrderResponse = await this.getMediaOrderInfo(table, cdb_id);

        let missingSizes = this.getMissingSizes(table, mediaOrderResponse.media_order_sizes)

        if (missingSizes.length) {
            return await this.orderMedia(table, cdb_id, missingSizes);
        } else {
            await this.wait(3000);
            return mediaOrderResponse.media_order;
        }
    }

    getMediaOrderInfo(table: string, cdb_id: string | number): Promise<any> {
        return new Promise((resolve, reject) => {
            this.http.get(`/api/media_orders/get_media_order/${table}/${cdb_id}`)
                .subscribe({
                    next(response: any) {
                        resolve(response);
                    },
                    error(err: any) {
                        reject(err);
                    }
                });
        });
    }

    getMissingSizes(table: string, media_order_sizes: any[]) {
        let missingSizes: string[] = [];

        for (let size of media_order_sizes) {
            if (table == 'new_games' && size.media_size_name == 'decal') {
                continue;
            }

            if (['vector', 'promo', 'spread'].includes(size.media_size_name)) {
                continue;
            }

            if (!size.id || !size.valid) {
                missingSizes.push(size.media_size_name);
            }
        }

        return missingSizes;
    }

    orderMedia(table: string, cdb_id: string | number, sizes: string[]): Promise<any> {
        return new Promise((resolve, reject) => {
            this.http.get(`/media_orders/json_order_cdb/cdb/${table}/${cdb_id}/${sizes.join(',')}`)
                .subscribe({
                    next(response: any) {
                        resolve(response.media_order);
                    },
                    error(err: any) {
                        reject(err);
                    }
                });
        });
    }

    wait(timeoutMs: number) {
        return new Promise((resolve) => {
            setTimeout(resolve, timeoutMs);
        });
    }

}
